document.querySelector('button')...